import { connect } from 'react-redux';
import { MainContentBlockPending } from '../pageStructure/mainContentBlockPending/MainContentBlockPending';
import ChooseRepaymentAmount from './chooseRepaymentAmount/ChooseRepaymentAmount';
import { useStateKey } from '../../iwQueryClient/useStateKey';
import { useEffect } from 'react';
import { trackPageView } from '../../tracking/pageView';
import { TruelayerConfirmation } from './truelayer/TruelayerConfirmation';
import { RootState } from '@iwProvider/configureStore';
import ConfirmRepayment from './confirmRepayment/ConfirmRepayment';
import IwStripeProvider from '../../iwStripeProvider/IwStripeProvider';
import { getEarlyRepaymentStripeKey } from './EarlyRepaymentSelector';

const mapStateToProps = (state: RootState) => ({
    ...state.earlyRepayment,
    stripeKey: getEarlyRepaymentStripeKey(state)
});

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

const EarlyRepayment = (props: PropsFromRedux) => {
    const stateKey = useStateKey();
    const { ready, step, stripeKey } = props;

    useEffect(() => {
        if (ready) {
            trackPageView(stateKey, 'Early Repayment');
        }
    }, [stateKey, ready]);

    if (ready) {
        switch (step) {
            case 'CHOOSE_REPAYMENT_AMOUNT':
                return <ChooseRepaymentAmount {...props} />;
            case 'CONFIRM_REPAYMENT':
                return (
                    // @ts-expect-error component not yet in TS
                    <IwStripeProvider stripeKey={stripeKey}>
                        <ConfirmRepayment />;
                    </IwStripeProvider>
                );
            case 'SHOW_TRUELAYER_CONFIRMATION':
                return <TruelayerConfirmation />;
        }
    }

    return <MainContentBlockPending data-testid="early-repayment-loading" />;
};

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(EarlyRepayment);
